'use client';

import { ImageSize } from '@fdc/types/image-model';
import { CoreButton } from '@woolworthslimited/core-components-react/button';

import { ITile } from '../../../types/tiles-model';
import { RichText } from '../rich-text/rich-text';

import { LinkImageHorizontalCutoff } from './image-link';
import styles from './tile.module.scss';

/** FDC attempt at making ultra reusable Card/Tile that will move to core later. Please keep decoupled. */
export const Tile = ({
  imageAlt,
  imgUrl,
  imgAriaLabel,
  heading,
  paragraph1,
  paragraph2,
  btnText,
  btnAltText,
  btnClickHandler,
  imgClickHandler,
  isDesktopView = true,
}: ITile) => {
  return (
    <section className={styles.tile}>
      {imgUrl && (
        <LinkImageHorizontalCutoff
          showLogo={false}
          image={{
            url: imgUrl,
            alt: imageAlt,
            imgAriaLabel: imgAriaLabel, // || getScreenReaderText(heading, logo?.logoAlt),
            handleCardClickEvent: imgClickHandler,
            size: ImageSize.Width300,
          }}
        />
      )}

      <div className="richtext">
        <RichText
          heading={heading}
          paragraph1={paragraph1}
          paragraph2={paragraph2}
        />
      </div>
      {btnText && (
        <div className={styles.actionButtonContainer}>
          <CoreButton
            label={btnText}
            ariaLabel={btnAltText}
            variant="secondary"
            isFullWidth={!isDesktopView}
            clickHandler={btnClickHandler}
          />
        </div>
      )}
    </section>
  );
};
